<template>
  <div id="hresh1x-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM4GEC2']['40'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive">

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['10'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.numseq }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['20'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.codpunsh }} - {{ data.desc_codpunsh }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['30'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.desc_typpun }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['40'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ setDateOutput(data.dtestart) }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC3']['50'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ setDateOutput(data.dteend) }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['60'] }}</label>
              <div class="col-md-5">
                <textarea class="form-control readonly-field-color" readonly="readonly">{{ data.remark }}</textarea>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['70'] }}</label>
              <div class="col-md-5">
                <input type="radio" value="Y" v-model="data.flgexempt" disabled="disabled" /> <label>{{ labels['HRPM4GEC3']['80'] }}</label>
                <input type="radio" value="N" v-model="data.flgexempt" disabled="disabled" /> <label>{{ labels['HRPM4GEC3']['90'] }}</label>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['100'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ data.codexemp }} - {{ data.desc_codexemp }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['110'] }}</label>
              <div class="col-md-5">
                <input type="radio" value="Y" v-model="data.flgblist" disabled="disabled" /> <label>{{ labels['HRPM4GEC3']['120'] }}</label>
                <input type="radio" value="N" v-model="data.flgblist" disabled="disabled" /> <label>{{ labels['HRPM4GEC3']['130'] }}</label>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC3']['140'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ data.coduser }}</div>
              </div>
              <label class="col-md-1 control-label">{{ labels['HRPM4GEC3']['150'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color">{{ setDateOutput(data.dteupd) }}</div>
              </div>
            </div>
          </form>

        </div>         
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hresh1x-detail-tab2',
  props: [ 'labels', 'data', 'tab2Table' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab2.vue?01ffda23